import { SidebarGroup, SidebarMenu, SidebarMenuItem } from "ui";

import { ChatButton } from "src/chat/ChatButton";
import { NotificationButton } from "src/notifications/Notifications";

export function SidebarCommunicationActions() {
  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <ChatButton sidebar />
        </SidebarMenuItem>
        <SidebarMenuItem>
          <NotificationButton sidebar />
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
